import React, { useContext } from "react";
import { LoaderWrapper, ManageMastersLayout } from "../../../components";
import GenericTable from "./GenericTable";
import { manageMasterStore } from "../../../contexts";
import { useRequest } from "../../../abstracts";
import { getAllAdvisors } from "../../../services";
import { isEmpty, get } from "lodash";

const AdvisorContainer = (props) => {
  const { state, dispatch } = useContext(manageMasterStore);
  const { response: advisors, loading } = useRequest({
    method: getAllAdvisors,
    defaultResponse: [],
  });
  console.log("clearingPartnerList", advisors);
  return (
    <ManageMastersLayout layoutHeader="Advisor">
      <LoaderWrapper loading={loading}>
        <div className="clearing-partner-container">
          <div className="clearing-partner-subjects">
            <div className="clearing-partner-recently-added">
              Recently Added/Modified
            </div>
            <div className="clearing-partner-records">
              {get(advisors, "advisors", [])?.length} Records found
            </div>
          </div>
          <div className="clearing-partner-list-container">
            {!isEmpty(get(advisors, "advisors", [])) && (
              <GenericTable
                state={state}
                dispatch={dispatch}
                advisors={get(advisors, "advisors", [])}
              />
            )}
          </div>
        </div>
      </LoaderWrapper>
    </ManageMastersLayout>
  );
};

export default AdvisorContainer;
